import { Typography, Grid } from "@mui/material";

export default function RedQuickStepperPanel(props: {
    title: string,
    children: any
}) {


    return (
        <>
            <Typography variant="h5" gutterBottom sx={{ mb: 2 }}>
                {props.title}
            </Typography>
            <form >
                <Grid container spacing={3}>
                    {props.children}
                </Grid>
            </form>
        </>
    );
}